import { useCallback, useState } from 'react';

import { SwingMessage, SwingThreadInput, MessageProps } from '../components';

import * as css from './SwingThreadMessages.css';

export type SwingThreadMessageDeletePayload = {
    id: number;
    threadId: number;
};

export type SwingThreadMessagesProps = {
    threadId: number;
    messages: MessageProps[];
    currentUserId: string;
    onUpsert: (payload: { message: string; id?: number; threadId: number }) => void;
    onDelete: (payload: SwingThreadMessageDeletePayload) => void;
    onEditMainComment: () => void;
};

export const SwingThreadMessages = ({
    messages,
    threadId,
    currentUserId,
    onUpsert,
    onDelete,
    onEditMainComment,
}: SwingThreadMessagesProps) => {
    const [editMessageIndex, setEditMessageIndex] = useState<number | null>(null);
    const toggleEditMessage = useCallback(
        (id: number | null) => {
            if (id === messages[0].id) {
                onEditMainComment();
                return;
            }
            setEditMessageIndex(id);
        },
        [messages, onEditMainComment],
    );
    return (
        <>
            <section className={css.messages}>
                {messages.map(({ id, ...message }) => (
                    <SwingMessage
                        currentUserId={currentUserId}
                        isEditingMessage={id === editMessageIndex}
                        toggleEditMessage={toggleEditMessage}
                        onUpsert={onUpsert}
                        onDelete={onDelete}
                        key={id}
                        id={id}
                        {...message}
                    />
                ))}
            </section>

            {!editMessageIndex && <SwingThreadInput threadId={threadId} onSubmit={onUpsert} />}
        </>
    );
};
